import { inject, Injectable } from '@angular/core';

import { MapGeohashService } from '@connect-services/client/services/map/geohash/map-geohash.service';
import { MapBaseService } from '@connect-services/client/services/map-base.service';

@Injectable({
    providedIn: 'root',
})
export class MapInteractionService extends MapBaseService {
    private readonly mapGeoHashService = inject(MapGeohashService);

    public onResize(): void {
        if (!this.map) {
            return;
        }

        this.map.redraw();
    }

    public onZoomEnd(): void {
        if (!this.map) {
            return;
        }

        this.mapGeoHashService.syncGeohashToMap(this.map);
    }
}
